// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dWQ6","label":"styles_label__32lKT"};